import { render, staticRenderFns } from "./CreateOrEditTenant.vue?vue&type=template&id=793cb9fa&scoped=true&"
import script from "./CreateOrEditTenant.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793cb9fa",
  null
  
)

export default component.exports